import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
import { skeletonVariants } from './Skeleton.variants';
import type { SkeletonVariantProps } from './Skeleton.variants';
type SkeletonProps = SkeletonVariantProps & {
  className?: string;
};
const Skeleton = t0 => {
  const $ = _c(5);
  const {
    variant,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== variant) {
    t1 = classNames(skeletonVariants({
      variant
    }), className);
    $[0] = className;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className={t1} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Skeleton;